import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import resources from "./locales";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en",
    // defaultNS: getTenantNameFromHost(),
    fallbackNS: "translation",
    // debug: process.env.NODE_ENV === "development",
    resources,
    keySeparator: false,
    nonExplicitSupportedLngs: true,
    // loadPath: '/locales/{{lng}}/{{ns}}.json'
  });

export default i18n;
